export default __webpack_public_path__ + "static/media/avatar-border.107ffdee.png";